<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <div class="overflow-auto" style="height: 33vh">
        <table class="table table-bordered">
          <thead class="ts-bg-gray-200">
            <tr>
              <th class="text-center" valign="middle" rowspan="2">
                {{ parentSubjectName }}
              </th>
              <th
                class="ts-text-xs text-center"
                :colspan="gradingDefiniton.length"
              >
                ACADEMIC ACHIEVEMENT
              </th>
            </tr>
            <tr>
              <th
                class="ts-text-xs text-center"
                v-for="(grading, index) in gradingDefiniton"
                :key="index"
              >
                <span class="badge bg-info rounded-pill">{{
                  grading.grade
                }}</span>
                <br />
                {{ grading.definition_name_en }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in datatable" :key="index">
              <td>
                <span class="badge badge-primary ts-text-xs">{{
                  getComponentName(item.sc_subject_id)
                }}</span>
              </td>
              <td
                v-for="(grading, indexColumn) in gradingDefiniton"
                :key="indexColumn"
                class="text-center"
              >
                <label :for="index + '_grade_' + indexColumn">
                  <input
                    :id="index + '_grade_' + indexColumn"
                    type="radio"
                    v-model="item.grade"
                    :value="grading.grade"
                    :checked="item.grade === grading.grade ? true : false"
                    class="ts-cursor-pointer ts-text-lg"
                  />
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'learning-strands-rating',
  props: ['value', 'modelData', 'electiveSubjects', 'validate'],
  data () {
    return {
      datatable: [],
      waiting: false,
      loading: false,
      show_alert: false,
      errors: new Errors(),
      gradingDefiniton: [],
      loadingPreData: false,
      model: {}
    }
  },
  created () {
    this.model = this.modelData
    this.fetchData()
  },
  computed: {
    parentSubjectName () {
      return this.electiveSubjects.length
        ? this.electiveSubjects[0].parent
          ? this.electiveSubjects[0].parent.subject_name_foreign
          : ''
        : ''
    }
  },
  methods: {
    async fetchData () {
      this.loading = true
      await this.getGradingDefiniton()
        .then(response => {
          this.gradingDefiniton = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    pushToDatatable () {
      this.datatable = []
      this.value.forEach(data => {
        let detail = Object.assign({}, this.newItem, data, {
          scoring_id: data.scoring_id,
          sc_subject_id: data.sc_subject_id,
          grade: data.grade
        })
        this.$nextTick(() => {
          this.datatable.push(detail)
        })
      })
    },
    getComponentName (sc_subject_id) {
      return this.electiveSubjects
        .filter(c => c.subject_id == sc_subject_id)
        .reduce((init, item) => (init = item.subject_name_foreign), null)
    },
    getGradingDefiniton() {
      return this.$store.dispatch('gradingDefinition/fetch', {
        fields: {
          score_grading_definitions: 'grade,definition_name_en'
        },
        filter: {
          acp_id: this.model.acp_id,
          acps_id: this.model.acps_id,
          definition_type: 'Rating'
        },
        page: -1
      })
    }
  },
  watch: {
    value: {
      handler (val) {
        if (_.isEqual(val, this.datatable)) return

        this.pushToDatatable()
      },
      deep: true,
      immediate: true
    },

    datatable: {
      handler (val) {
        if (_.isEqual(val, this.value)) return

        this.$emit('input', val)
      },
      deep: true
    },
    validate: {
      handler () {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
}
table > thead {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px;
}
table > thead > tr > th {
  padding: 4px 7px;
}
table > tbody > tr > td {
  padding: 4px 7px;
}
.bb {
  border-bottom: 1px solid #d8d8d8;
  outline: none;
}
label {
  display: block;
  margin-bottom: 0;
}

input[type='radio'] {
  appearance: none;
  background-color: #fff;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 2px;
  display: inline-grid;
  place-content: center;
}

input[type='radio']::before {
  content: '';
  width: 10px;
  height: 10px;
  transform: scale(0);
  transform-origin: bottom left;
  background-color: #fff;
  clip-path: polygon(13% 50%, 34% 66%, 81% 2%, 100% 18%, 39% 100%, 0 71%);
}

input[type='radio']:checked::before {
  transform: scale(1);
}
input[type='radio']:checked {
  background-color: #348fe2;
  border: 2px solid #348fe2;
}
</style>
